import React from "react";
import { SceneTitleProps } from "./SceneTitleModel";
import styles from "./SceneTitle.module.scss";

const SceneTitle = ({ children, title }: SceneTitleProps) => (
  <div className={styles.sceneTitleContainer}>
    <h1>{title}</h1>
    <div className={styles.sceneTitleWrapper}>{children}</div>
  </div>
);

export default SceneTitle;
